export default __webpack_public_path__ + "static/media/logo.893a87a0.png";